import * as React from 'react';
import { Layer } from 'react-map-gl';
import type { LayerProps } from 'react-map-gl';

import { IUIMapLayer } from '@components/common/UIMap/utils/types';

export const pointLayer: LayerProps = {
  type: 'circle',
  paint: {
    'circle-color': '#11b4da',
    'circle-radius': 4,
    'circle-stroke-width': 1,
    'circle-stroke-color': '#fff',
  },
};

const UIPointLayer = (props: IUIMapLayer) => {
  const { id, ...rest } = props;

  const layerProps = {
    ...pointLayer,
    ...rest,
  };

  return <Layer key={id} id={id} {...layerProps} />;
};

export default UIPointLayer;
